export default __webpack_public_path__ + "static/media/Square.5837172a.svg";